export default value => !!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);